import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Catalog from "../components/catalog"
import { graphql } from "gatsby"

const IndexPage = ({data}) => (
  <Layout>
    <SEO title="Product Catalog" />
    <Catalog products={data.allAlmoProductsJson.edges} />
  </Layout>
)

export const query = graphql`
      {
          allAlmoProductsJson {
              edges {
                  node {
                      item_code
                      animal
                      item_description
                      brand_name_new
                      brand
                      segment_range_new
                      recipe
                      card_image_main
                  }
              }
          }
      }
  `

export default IndexPage
